Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

/** Detect CommonJS. */
function isCjs() {
  return typeof require !== 'undefined';
}

exports.isCjs = isCjs;
//# sourceMappingURL=commonjs.js.map
